import phaser from "./phaser/index.js";
import menu from "./menu/index.js";

export { phaser, menu };
export default { phaser, menu };
